import React from 'react'
import AnalysisEmptyState from './AnalysisEmptyState'
import AnalysisPageLoader from './AnalysisPageLoader'

export { AnalysisPageLoader }
export type AnalysisTone = 'coral' | 'amber' | 'teal' | 'muted'

export function pctTone(
  value: number,
  invert = false
): AnalysisTone {
  if (!value && value !== 0) return 'muted'
  const v = invert ? 100 - value : value
  if (v >= 60) return 'coral'
  if (v >= 30) return 'amber'
  if (v > 0) return 'teal'
  return 'muted'
}

export function barFill(tone: AnalysisTone) {
  if (tone === 'coral') return '#D14A3E'
  if (tone === 'amber') return '#C98A16'
  if (tone === 'teal') return '#0D9B87'
  return '#CDD8D6'
}

export function AnalysisChartCard({
  title,
  hasData = true,
  children,
}: {
  title: string
  hasData?: boolean
  children?: React.ReactNode
}) {
  return (
    <div className={`ma-card${hasData ? '' : ' is-empty'}`}>
      <div className="ma-card-head">
        <h3>{title}</h3>
      </div>
      <div className="ma-card-body ma-card-body--chart">
        {hasData ? children : <AnalysisEmptyState />}
      </div>
    </div>
  )
}

export function AnalysisSection({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) {
  const items = React.Children.toArray(children).filter(Boolean)
  if (!items.length) return null
  return (
    <>
      <p className="ma-section-label">{label}</p>
      <div className="ma-chart-grid">{items}</div>
    </>
  )
}

export function AnalysisKpiCard({
  label,
  value,
  suffix,
  tone = 'muted',
  description,
  progress,
  stampTitle,
}: {
  label: string
  value: string | number
  suffix?: string
  tone?: AnalysisTone
  description?: string
  progress?: number
  stampTitle?: string
}) {
  const pct = Math.min(100, Math.max(0, Number(progress) || 0))
  return (
    <div className="ma-kpi">
      <span className="ma-kpi-stamp" title={stampTitle}>
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="2.5" y="3.5" width="11" height="10" rx="1.5" />
          <path d="M2.5 6.5h11M5.5 2.5v2M10.5 2.5v2" />
        </svg>
      </span>
      <p className="ma-kpi-eyebrow">{label}</p>
      <div className={`ma-kpi-value is-${tone}`}>
        {value}
        {suffix ? <span className="ma-kpi-suffix">{suffix}</span> : null}
      </div>
      {progress !== undefined ? (
        <div className="ma-bar-track">
          <span
            className="ma-bar-fill"
            style={{ width: `${pct}%`, background: barFill(tone) }}
          />
        </div>
      ) : null}
      {description ? <p className="ma-kpi-desc">{description}</p> : null}
    </div>
  )
}
